import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useEffect } from "react";

export default function TermsOfUse() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="terms-of-use-page">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 md:px-12 pt-32 pb-[20px]">
        <h1 className="font-heading text-[30px] sm:text-[45px] font-semibold text-[#08122a] tracking-tight leading-tight mb-4">Terms of Use</h1>
        <p className="font-body text-sm text-[#475569] mb-12">Last updated: February 1, 2026</p>

        <div className="space-y-10 font-body text-[#475569] text-base leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">1. Acceptance of Terms</h2>
            <p>By accessing and using the Nebula Flow website, you accept and agree to be bound by these Terms of Use. If you do not agree with any part of these terms, you should not use our website.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">2. Use of Website</h2>
            <p>The content on this website is provided for general informational purposes only. It does not constitute an offer to sell or a solicitation of an offer to buy any securities, nor does it constitute investment advice or a recommendation.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">3. Intellectual Property</h2>
            <p>All content on this website, including text, graphics, logos, design elements, and software, is the property of Nebula Flow or its licensors and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works without our prior written consent.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">4. No Investment Advice</h2>
            <p>Nothing on this website should be construed as investment, legal, tax, or other professional advice. Past performance of any portfolio company or investment is not indicative of future results. All investment decisions involve risk, and you should consult with qualified professionals before making any investment decisions.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">5. Limitation of Liability</h2>
            <p>Nebula Flow shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising out of your access to or use of this website. We make no warranties or representations about the accuracy or completeness of the content on this site.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">6. External Links</h2>
            <p>Our website may contain links to third-party websites. These links are provided for convenience only, and we do not endorse or assume responsibility for the content, privacy policies, or practices of any third-party sites.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">7. Governing Law</h2>
            <p>These Terms of Use shall be governed by and construed in accordance with the laws of England and Wales.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">8. Modifications</h2>
            <p>We reserve the right to modify these Terms of Use at any time. Changes will be effective immediately upon posting on this page. Your continued use of the website after changes are posted constitutes your acceptance of the revised terms.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">9. Contact</h2>
            <p>For questions regarding these Terms of Use, please contact us at info@nebula-f.com or at 2 Eastbourne Terrace, Paddington, London W2 6LG, UK.</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
